/**
 * Removes query parameters from the current URL, typically after they've been consumed.
 *
 * @param  {...string} params The query parameters to strip from the current URL
 */
export const removeQueryParams = (...params) => {
  const urlSearchParams = new URLSearchParams(window.location.search);
  params.forEach(param => {
    urlSearchParams.delete(param);
  });

  const newQueryString =
    urlSearchParams.size ? `?${urlSearchParams.toString()}` : '';

  history.replaceState(null, '', `${window.location.pathname}${newQueryString}${window.location.hash}`);
};
